<app-auth-shell
  title="Verify your identity"
  [subtitle]="'A one-time passcode was sent to ' + email() + '.'"
>
  <form [formGroup]="form" (ngSubmit)="submit()" class="auth-form">
    <mat-form-field appearance="outline">
      <mat-label>One-time passcode</mat-label>
      <input
        matInput
        type="text"
        inputmode="numeric"
        formControlName="otp"
        autocomplete="one-time-code"
      />
      @if (form.controls.otp.invalid && form.controls.otp.touched) {
        <mat-error>Enter the OTP sent to your email</mat-error>
      }
    </mat-form-field>

    @if (errorMessage(); as message) {
      <p class="auth-error">{{ message }}</p>
    }

    <button mat-flat-button color="primary" type="submit" [disabled]="loading()" class="auth-submit">
      @if (loading()) {
        <mat-spinner diameter="20" />
      } @else {
        Verify
      }
    </button>
  </form>
</app-auth-shell>
